import { useEffect, useRef } from "react";
import { loadSpace } from "@usersnap/browser";

export const useUsersnap = (apiKey: string, enabled: boolean = false) => {
  const isInitialized = useRef(false);

  useEffect(() => {
    // Don't initialize if disabled, not in browser, or missing API key.
    if (!enabled || isInitialized.current || !apiKey) {
      return;
    }

    void loadSpace(apiKey).then((api) => {
      void api.init();
      isInitialized.current = true;
    });
  }, [apiKey, enabled]);

  return null;
};
